import { render, staticRenderFns } from "./request-to-nobodies.vue?vue&type=template&id=2d936337"
import script from "./request-to-nobodies.vue?vue&type=script&lang=js"
export * from "./request-to-nobodies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports